import { createRequest } from '@savgroup-front-common/core/src/services/request';

export const LOAD_FILE_INFO = createRequest('FILE_INFO/LOAD_FILE_INFO');
